import { Liquid } from 'liquidjs';

const baseLiquidEngine = new Liquid();
export default function renderBaseLiquid(template: string, variables: Record<string, unknown>): string {
  return baseLiquidEngine.parseAndRenderSync(template, variables);
}
